import { render, staticRenderFns } from "./componente-localentrega-novo.vue?vue&type=template&id=aa4fdd70"
import script from "./componente-localentrega-novo.vue?vue&type=script&lang=js"
export * from "./componente-localentrega-novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports